// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { filterListStyles } from "@tps/Overrides/Widgets/ProductList/ProductListFilterList";
import { xScreen } from "@tps/XDL/Utilities";
import { css } from "styled-components";

filterListStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: column;
        align-items: flex-start;
        width: 100%;
    `,
};

filterListStyles.filterText = {
    variant: "h5",
    weight: "bold",
    css: css`
        margin-bottom: 0;
    `,
};

filterListStyles.clearAllLink = {
    typographyProps: {
        variant: "h6",
        size: 14,
        css: css`
            margin-bottom: 0;
            line-height: 22px;
        `,
    },
    css: css`
        ${xScreen("lte", "md")} {
            display: none;
        }
    `,
};

filterListStyles.tags = {
    wrapper: {
        css: css`
            display: flex;
            flex-wrap: wrap;
            width: 100%;
        `,
    },
    titleWrapper: {
        css: css`
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-bottom: 12px;
            ${xScreen("lte", "md")} {
                display: none;
            }
        `,
    },
};
